module.exports = __webpack_public_path__ + "static/media/brief_marker_modal.295dffb4.gif";